<script>
	// The params prop contains values matched from the URL
	export let params = {} 

	import { replace, push } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import BarraOperacoesRegistro from '../../componentes/BarraOperacoesRegistro.svelte';
	import { sTituloPaginaAtual } from '../../stores';
	import { 
		API, 
		TipoEvento,
		StatusHttp, 
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS, 
		TextoFeedback,
		ativarLinksEmTexto, 
		rolarPagina, 
		TipoPerfil } from '../../utils';

	const dispatch = createEventDispatcher();
	let projeto = {};
	let dadosUsuario;
	let opcoesOperacoes = [];
	let opcoesOperacoesTopo = [];
	let opcoesOperacoesRodape = [];
	let participantes = [];
	let avaliacoes = [];
	let relatorios = [];
	let lista_resumo_relatorios = [];
	let distribuicoes = [];
	let anexos = [];
	let perfilUsuarioToken = "";

	onMount(async () => {
		$sTituloPaginaAtual = `Impressão de Projeto (cód.: ${params.codigo})`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projeto ...',
		});
		
		dadosUsuario = dadosUsuarioLS();
		perfilUsuarioToken = dadosUsuario.perfil;

		const resposta = await fetch(API(`projetos/${params.codigo}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});
		
		const { dados, status } = await resposta.json();
		
		if (status == StatusHttp.OK) {
			projeto = dados;

			// console.log(dados);
			participantes = projeto.participantes;
			avaliacoes = projeto.avaliacoes ?? [];
			distribuicoes = projeto.distribuicoes;
			anexos = projeto.anexos;
			relatorios = projeto.relatorios ?? [];
			lista_resumo_relatorios = projeto.lista_resumo_relatorios ?? [];

			document.title = `AVAL # Projeto ${projeto.codigo}`;
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/projeto-inexistente');

			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	const imprimirPagina = () => {
		let esconderAvisoImprimir = document.getElementById("botaoImprimir");
		esconderAvisoImprimir.remove();
		window.print();
	}
</script>

<div class="notification is-danger m-3 has-text-centered" id="botaoImprimir">
	Clique no botão abaixo para imprimir a página.
	<br>
	<br>

	<button class="button is-black" on:click|preventDefault={imprimirPagina}>IMPRIMIR</button>
</div>

<div class="has-text-centered mb-6">
	<h1 class="title is-1 mb-6">{projeto.titulo}</h1>

	<h3 class="subtitle is-4">
		Alocação: {projeto.alocacao}
		<br>
		Modalidade: {projeto.modalidade}
		<br>
		Unidade do projeto: {projeto.unidade}
	</h3>
</div>

<table class="table is-bordered is-fullwidth">
	<tr>
		<td>Código do projeto</td>
		<td><strong>{ projeto.codigo }</strong></td>
		<td>Total de bolsas solicitadas</td>
		<td><strong>{ projeto.total_bolsas }</strong></td>
	</tr>
	<tr>
		<td>Data de cadastro</td>
		<td><strong>{ projeto.data_criacao }</strong></td>
		<td>Última atualização</td>
		<td><strong>{ projeto.data_ultima_atualizacao }</strong></td>
	</tr>
</table>
	
<div class="px-4">
	{@html projeto.descricao}
</div>

<p class="has-text-centered is-size-1"><strong>* * * * * * * *</strong></p>

{#if anexos?.length > 0}
	<p class="is-size-4 mb-4 ml-4">Anexos</p>
	
	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>Tipo</th>
				<th>Valor</th>
			</tr>
		</thead>
		<tbody>
			{#each anexos as anexo}
			<tr>
				<td>{ anexo.tipo }</td>
				<td>{ anexo.valor.trim() }</td>
			</tr>
			{/each}
		</tbody>
	</table>
{/if}

{#if participantes?.length > 0}

<p class="is-size-4 mb-4 ml-4">Participantes</p>

<table class="table is-bordered is-fullwidth">
	<thead>
		<tr>
			<th>Nome</th>
			<th>E-mail</th>
			<th>Unidade</th>
			<th>Papel</th>
		</tr>
	</thead>
	<tbody>
		{#each participantes as participante}
		<tr class="{participante.ativo !== true ? 'riscar-linha' : ''}">
			<td>{ participante.nome }</td>
			<td>{ participante.email }</td>
			<td>{ participante.unidade }</td>
			<td>{ participante.papel }</td>
		</tr>
		{/each}
	</tbody>
</table>
{/if}

<h1 class="title is-2 mt-6 mb-6 has-text-centered">Histórico de Avaliações</h1>

<table class="table is-fullwidth is-bordered">
	<thead>
		<tr>
			<th>Ano</th>
			<th>Status da avaliação</th>
			<th>Pontuação</th>
		</tr>
	</thead>
	<tbody>
		{#each avaliacoes as avaliacao}
		<tr>
			<td>{ avaliacao.ano_ultima_atualizacao }</td>
			<td class="has-text-right">{ avaliacao.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
			<td>{ avaliacao.pontuacao }</td>
		</tr>
		{:else}
		<tr>
			<td colspan="6">Nenhuma avaliação ainda.</td>
		</tr>
		{/each}
	</tbody>
</table>

<h1 class="title is-2 mt-6 mb-6 has-text-centered">Relatórios</h1>

{#each relatorios as relatorio}

<div class="m-3 p-3" style="border:2px solid #000">
	<p>Tipo: { relatorio.tipo }</p>
	<p>Adicionado em:  { relatorio.data_criacao }</p>
	
	<hr>
	{@html relatorio.conteudo}
</div>
<br>
{:else}
<p class="has-text-centered mb-6">Nenhum relatório cadastrado.</p>
{/each}